import React from 'react';
import CoordinateInput from './CoordinateInput';
import { copyToClipboard } from '../../utils/coordinateTool';

export default function SingleConvertPanel({
  inputLat,
  setInputLat,
  inputLng,
  setInputLng,
  handleCoordinatePaste,
  handleConvert,
  handleCoordinateParse,
  loading,
  result,
  handleExport
}) {
  return (
    <div>
      <CoordinateInput
        label="纬度"
        value={inputLat}
        onChange={setInputLat}
        placeholder={`例如: 39.9042 或 39°54'15.12"N 或粘贴完整坐标`}
        onPaste={(e) => handleCoordinatePaste(e, 'inputLat')}
      />
      <CoordinateInput
        label="经度"
        value={inputLng}
        onChange={setInputLng}
        placeholder={`例如: 116.4074 或 116°24'26.64"E 或粘贴完整坐标`}
        onPaste={(e) => handleCoordinatePaste(e, 'inputLng')}
      />
      <button
        onClick={handleConvert}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? '转换中...' : '转换'}
      </button>
      <button
        onClick={handleCoordinateParse}
        style={{
          padding: '10px 20px',
          background: '#4caf50',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginLeft: 10
        }}
      >
        智能识别
      </button>

      <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
        💡 提示：可以直接粘贴坐标（如：119.134350,28.076690），系统会自动识别并分离经纬度
      </div>

      {result && (
        <div style={{ marginTop: 20, padding: 15, background: '#f5f5f5', borderRadius: '4px' }}>
          <h4>转换结果</h4>
          {result.error ? (
            <div style={{ color: 'red' }}>{result.error}</div>
          ) : (
            <div>
              <div><strong>纬度:</strong> {result.converted.lat}</div>
              <div><strong>经度:</strong> {result.converted.lng}</div>
              {result.converted.formatted && (
                <div><strong>格式化:</strong> {result.converted.formatted.lat}, {result.converted.formatted.lng}</div>
              )}
              <div style={{ marginTop: 10 }}>
                <button
                  onClick={() => copyToClipboard(`${result.converted.lat},${result.converted.lng}`)}
                  style={{ marginRight: 10, padding: '5px 10px', background: '#4caf50', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer' }}
                >
                  复制坐标
                </button>
                <button
                  onClick={() => handleExport([result.converted], 'CSV', 'coordinate_export')}
                  style={{ padding: '5px 10px', background: '#ff9800', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer' }}
                >
                  导出CSV
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
